import React from 'react';
import { Shield, Lock } from 'lucide-react';

const Footer = ({ onPageChange }) => {
  return (
    <footer className="bg-black !bg-black border-t border-gray-800 mt-auto relative z-50" style={{ backgroundColor: '#000000' }}>
      <div className="container mx-auto px-4 py-6">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="flex items-center space-x-2 mb-4 md:mb-0">
            <div className="w-8 h-8 bg-gradient-to-br from-purple-600 to-blue-600 rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-sm">E</span>
            </div>
            <span className="text-white font-semibold">Enable.AI</span>
          </div>
          
          <div className="flex items-center space-x-6">
            <button
              onClick={() => onPageChange('privacy')}
              className="flex items-center space-x-2 text-gray-300 hover:text-purple-400 transition-colors duration-300"
            >
              <Shield className="w-4 h-4" />
              <span className="text-sm font-medium">Privacy Policy</span>
            </button>
            
            <button
              onClick={() => onPageChange('trust-security')}
              className="flex items-center space-x-2 text-gray-300 hover:text-blue-400 transition-colors duration-300"
            >
              <Lock className="w-4 h-4" />
              <span className="text-sm font-medium">Trust & Security</span>
            </button>
          </div>
        </div>
        
        <div className="mt-4 pt-4 border-t border-gray-800">
          <p className="text-center text-gray-400 text-sm">
            © 2025 WeEnable.AI. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 